import React, { useEffect, useRef } from 'react';


function SendEmail(props) {

useEffect(()=>
{
  sendEmail();
})
 
const sendEmail=(e)=>
{


const config={
      
    SecureToken:"65147da9-760f-456e-8730-db7d84e1bc7c",
    To : props.clientEmailId,
    From : "yogeshsaini2912@gmail.com",
    Subject : "Audyt Users Creation email",
    Body : `<h1>Hello ${props.clientName}</h1><p>You are just assigned as a role of ${props.clientrole}, please find your credentials below 
    <br></br>
    email: ${props.clientEmailId}
    <br></br>
    temporary password: changeme
    <br></br>
    Note: please reset your password in first login!!
    
   
    </p> 
    `, 
    ContentType: "text/html"

}
if(window.Email)
{
    window.Email.send(config).then(
      message => alert(message)
    ).catch(err=>alert(err))
}
  
}
 



  return (
    <div>
      </div>
  );
}

export default SendEmail;